/**
 * Not defterindeki yapılacaklar satırları.
 *
 * Not metni düz metin olarak saklanıyor ve Blazor ile paylaşılıyor
 * (`UserSettings["Notepad<id>"]`), o yüzden onay kutuları ayrı bir veri yapısı değil:
 * satır `- [ ]` ya da `- [x]` ile başlıyorsa kutu olarak çizilir. Metin her iki üründe
 * de okunabilir kalır, Blazor tarafında düz metin olarak görünür.
 */
export interface NoteLine {
  /** Satırın metindeki sırası (0 tabanlı). */
  index: number;
  /** Onay kutusu satırı değilse null. */
  checked: boolean | null;
  /** Kutu işareti çıkarılmış görünen metin. */
  text: string;
}

const TODO_RE = /^(\s*)[-*]\s\[([ xX])\]\s?(.*)$/;

export function parseNote(text: string): NoteLine[] {
  return text.split('\n').map((line, index) => {
    const m = TODO_RE.exec(line);
    if (!m) return { index, checked: null, text: line };
    return { index, checked: m[2]!.toLowerCase() === 'x', text: m[3] ?? '' };
  });
}

/** Satırdaki kutuyu ters çevirir; kutu satırı değilse metin aynen döner. */
export function toggleNoteLine(text: string, index: number): string {
  const lines = text.split('\n');
  const line = lines[index];
  if (line === undefined) return text;
  const m = TODO_RE.exec(line);
  if (!m) return text;
  const next = m[2]!.toLowerCase() === 'x' ? ' ' : 'x';
  lines[index] = `${m[1]}- [${next}] ${m[3] ?? ''}`;
  return lines.join('\n');
}

/** Tamamlanan/toplam sayısı — başlıktaki ilerleme göstergesi için. */
export function noteProgress(text: string): { done: number; total: number } {
  const todos = parseNote(text).filter((l) => l.checked !== null);
  return { done: todos.filter((l) => l.checked).length, total: todos.length };
}

/**
 * İmlecin bulunduğu satırın devamına yeni bir madde ekler (Enter davranışı).
 * Boş bir maddede Enter'a basılırsa madde kapatılır — listeden çıkmanın yolu bu.
 */
export function continueList(text: string, caret: number): { text: string; caret: number } | null {
  const before = text.slice(0, caret);
  const lineStart = before.lastIndexOf('\n') + 1;
  const line = before.slice(lineStart);
  const m = TODO_RE.exec(line);
  if (!m) return null;
  if ((m[3] ?? '').trim() === '') {
    // Boş madde: satırı temizleyip listeden çık.
    const next = text.slice(0, lineStart) + text.slice(caret);
    return { text: next, caret: lineStart };
  }
  const insert = `\n${m[1]}- [ ] `;
  return { text: text.slice(0, caret) + insert + text.slice(caret), caret: caret + insert.length };
}
